import React from "react";
import { Stack } from "@mui/material";
import { Link } from "react-router-dom";
import logo from "../assets/images/Logo.png";
const NavBar = () => {
  return (
    <Stack
      direction="row"
      justifyContent="space-around"
      sx={{
        gap: { sm: "122px", xs: "40px" },
        mt: { sm: "32px", xs: "20px" },
        justifyContent: "none",
        px:'20px'
      }}
    >
      <Link to={"/"}>
        {" "}
        <img
          src={logo}
          alt="logo"
          style={{ width: "48px", height: "48px", margin: "0 20px" }}
        />
      </Link>

      <Stack direction="row" gap="40px" fontSize="24px" alignItems="flex-end">
        <Link
          to={"/"}
          style={{ color: "#3a1212", borderBottom: "3px solid #ff2625" }}
        >
          {" "}
          Home
        </Link>
        <a href="#exercises" style={{ color: "#3a1212" }}>
          Exercises
        </a>
      </Stack>
    </Stack>
  );
};

export default NavBar;
